import axios from '../../http_v2'
export default {
    page: (params) => {
        return axios.post('activityservice/schedulemanage/page', params)
    },
    list: (params) => {
        return axios.get('activityservice/schedulemanage/list', params)
    },
    parent: (params) => {
        return axios.get('activityservice/schedulemanage/parent', params)
    },
    add: (params) => {
        return axios.post('activityservice/schedulemanage/save', params)
    },
    update: (params) => {
        return axios.post('activityservice/schedulemanage/update', params)
    },
    del: (params) => {
        return axios.post('activityservice/schedulemanage/remove', params)
    },
    delAll: (params) => {
        return axios.post('activityservice/schedulemanage/batchremove', params)
    }
}
